import { CheckoutPaymentMethod } from "./CheckoutPaymentMethod";

export default CheckoutPaymentMethod;
